import i18n from "@/plugins/i18n";

export const REQUEST_MAPPING = {
  COMMON_V1: "/api/v1/checkpoint",
  AUTH_V1: "/api/v1/auth",
  MEMBER_V1: "/api/v1/members",
  COMMENT: "/api/v1/comment",
  TARGET_SETTING_V1: "/api/v1/target-settings",
  TEAM_TARGET_V1: "/api/v1/team-target",
  TRANSFER_MEMBER_V1: "/api/v1/transfer-member",
  ASSESSMENT_CONFIG: "/api/v1/assessment-config",
  SETTINGS: "/api/v1/settings",
  DEPARTMENTS: "/api/v1/department",
  MEETING_MANAGEMENTS: "/api/v1/meeting-managements",
  DATA_COLLECTION: "/api/v1/collect-data",
};
export const API_PATH = {
  // common
  PING: REQUEST_MAPPING.COMMON_V1 + "/ping",
  YEARS: REQUEST_MAPPING.COMMON_V1 + "/years",
  GET_HEADS: REQUEST_MAPPING.COMMON_V1 + "/heads",
  GET_PERIOD_LIST: REQUEST_MAPPING.COMMON_V1 + "/future-year-sessions",
  LOGIN: REQUEST_MAPPING.AUTH_V1 + "/login",
  LOGOUT: REQUEST_MAPPING.AUTH_V1 + "/logout",
  GET_ROLE: REQUEST_MAPPING.AUTH_V1 + "/get-role",

  //Members
  GET_MEMBERS_BY_HEAD: REQUEST_MAPPING.MEMBER_V1,
  GET_PROFILE: REQUEST_MAPPING.MEMBER_V1 + "/get-profile",
  GET_TARGET_OF_MEMBER: REQUEST_MAPPING.MEMBER_V1 + "/get-target-of-member",
  SAVE_PERSONAL_GOAL: REQUEST_MAPPING.MEMBER_V1 + "/save-personal-goal",
  SAVE_ACCOMPLISHMENT: REQUEST_MAPPING.MEMBER_V1 + "/save-accomplishment",
  PROCESS_TARGET_SUB: REQUEST_MAPPING.MEMBER_V1 + "/process-target-sub",
  PROCESS_TARGET_SUBMIT: REQUEST_MAPPING.MEMBER_V1 + "/process-target-submit",
  PROCESS_TARGET_DELETE: REQUEST_MAPPING.MEMBER_V1 + "/delete-target-sub",
  PROCESS_TARGET_APPROVE: REQUEST_MAPPING.MEMBER_V1 + "/process-target-approve",
  PROCESS_TARGET_REJECT: REQUEST_MAPPING.MEMBER_V1 + "/process-target-reject",
  PROCESS_TARGET_ACCOMPLISHED:
    REQUEST_MAPPING.MEMBER_V1 + "/process-target-accomplished",
  TARGET_API_COMMENT: REQUEST_MAPPING.COMMENT + "/target",
  GET_POSITIONS: REQUEST_MAPPING.MEMBER_V1 + "/positions",
  PERSON_TARGET: REQUEST_MAPPING.COMMENT + "/person-target",
  GET_MEMBER_PROFILE_BY_ID: REQUEST_MAPPING.MEMBER_V1 + "/get-member-profile",
  GET_PARENTS_OF_MEMBER: REQUEST_MAPPING.MEMBER_V1 + "/get-parents",
  GET_TARGETS_HISTORY: REQUEST_MAPPING.MEMBER_V1 + "/targets-history",
  EXPORT_COMMITMENT: REQUEST_MAPPING.MEMBER_V1 + "/export-commitment",
  EXPORT_CSV: REQUEST_MAPPING.MEMBER_V1 + "/export-csv",
  MEMBER_TARGET_FILES: REQUEST_MAPPING.MEMBER_V1 + "/member-target-files",
  UPLOAD_MEMBER_TARGET_FILES:
    REQUEST_MAPPING.MEMBER_V1 + "/member-target-files/upload",
  DOWNLOAD_MEMBER_TARGET_FILES:
    REQUEST_MAPPING.MEMBER_V1 + "/member-target-files/download",
  DELETE_MEMBER_TARGET_FILES:
    REQUEST_MAPPING.MEMBER_V1 + "/member-target-files",
  MEMBER_TARGET_CHANGE_GRADE: REQUEST_MAPPING.MEMBER_V1 + "/force-change-grade",

  //Target-Settings
  TARGET_SETTING_CREATE: REQUEST_MAPPING.TARGET_SETTING_V1 + "/create",
  TARGET_SETTING_SAVE: REQUEST_MAPPING.TARGET_SETTING_V1 + "/save",
  TARGET_SETTING_DELETE_CP_TABLE:
    REQUEST_MAPPING.TARGET_SETTING_V1 + "/delete-cp-table",
  TARGET_SETTING_FILTER: REQUEST_MAPPING.TARGET_SETTING_V1 + "/filter",
  TARGET_SETTING_GET_HEADS: REQUEST_MAPPING.TARGET_SETTING_V1 + "/get-heads",
  TARGET_SETTING_SUBMIT: REQUEST_MAPPING.TARGET_SETTING_V1 + "/submit",
  TARGET_SETTING_REJECT: REQUEST_MAPPING.TARGET_SETTING_V1 + "/reject",
  TARGET_SETTING_ROLLBACK: REQUEST_MAPPING.TARGET_SETTING_V1 + "/rollback",
  TARGET_SETTING_APPROVE: REQUEST_MAPPING.TARGET_SETTING_V1 + "/approve",
  TARGET_SETTING_GET_YEAR_SESSION:
    REQUEST_MAPPING.TARGET_SETTING_V1 + "/get-year-session",
  TARGET_SETTING_GET_MAX_TARGET_SCORE:
    REQUEST_MAPPING.TARGET_SETTING_V1 + "/get-max-target-score",
  TARGET_SETTING_UPDATE_MAX_TARGET_SCORE:
    REQUEST_MAPPING.TARGET_SETTING_V1 + "/update-max-target-score",
  REGISTER_MISSION: REQUEST_MAPPING.TARGET_SETTING_V1 + "/register-mission",
  REGISTER_GOAL: REQUEST_MAPPING.TARGET_SETTING_V1 + "/register-goal",
  GET_MISSION_GOAL: REQUEST_MAPPING.TARGET_SETTING_V1 + "/get-mission-goal",

  //Team-Target
  FILTER_TEAM_TARGET: REQUEST_MAPPING.TEAM_TARGET_V1,
  TEAM_TARGET_PREVIOUS_SESSION:
    REQUEST_MAPPING.TEAM_TARGET_V1 + "/get-previous-session",
  TEAM_TARGET_CURRENT_SESSION: REQUEST_MAPPING.TEAM_TARGET_V1 + "/get-session",
  TEAM_TARGET_NEXT_SESSION:
    REQUEST_MAPPING.TEAM_TARGET_V1 + "/get-next-session",
  TEAM_TARGET_FORCE_POINT:
    REQUEST_MAPPING.TEAM_TARGET_V1 + "/force-change-process-point",
  TEAM_TARGET_REVIEW: REQUEST_MAPPING.TEAM_TARGET_V1 + "/review",
  TEAM_TARGET_COMMENT: REQUEST_MAPPING.TEAM_TARGET_V1 + "/get-comment",
  GET_ACTION_REVIEWS: REQUEST_MAPPING.TEAM_TARGET_V1 + "/get-action-reviews",
  GET_TARGET_SETTING: REQUEST_MAPPING.TEAM_TARGET_V1 + "/get-target-setting",
  EXPORT_BY_DEPARTMENT_API:
    REQUEST_MAPPING.TEAM_TARGET_V1 + "/export-by-department",

  //Member-Transfer
  FILTER_MEMBER_TRANSFER: REQUEST_MAPPING.TRANSFER_MEMBER_V1,
  MEMBER_TRANSFER_PREVIOUS_SESSION:
    REQUEST_MAPPING.TRANSFER_MEMBER_V1 + "/get-previous-session",
  MEMBER_TRANSFER_NEXT_SESSION:
    REQUEST_MAPPING.TRANSFER_MEMBER_V1 + "/get-next-session",
  MEMBER_TRANSFER_CURRENT_SESSION:
    REQUEST_MAPPING.TRANSFER_MEMBER_V1 + "/get-session",

  //Transfer members
  GET_ALL_TRANSFER_MEMBERS:
    REQUEST_MAPPING.TRANSFER_MEMBER_V1 + "/get-transfer-members",
  CONFIG_CP_TABLE_MEMBER:
    REQUEST_MAPPING.TRANSFER_MEMBER_V1 + "/config-cp-table",
  GET_HEAD_OF_TARGET_SETTING: REQUEST_MAPPING.TRANSFER_MEMBER_V1 + "/get-head",
  // Assessment config
  ASSESSMENT_CONFIGS_GET: REQUEST_MAPPING.ASSESSMENT_CONFIG,
  ASSESSMENT_CONFIGS_UPDATE: REQUEST_MAPPING.ASSESSMENT_CONFIG + "/update",
  CHECK_TARGET_AVAILABLE:
    REQUEST_MAPPING.ASSESSMENT_CONFIG + "/target-available",

  // Settings
  SETTING_CAN_VIEW_PEERS: REQUEST_MAPPING.SETTINGS + "/can-view-peers",

  // Departments
  GET_ALL_DEPARTMENTS: REQUEST_MAPPING.DEPARTMENTS,
  GET_HR_DEPARTMENTS: REQUEST_MAPPING.DEPARTMENTS + "/hr-departments",
  GET_DEPARTMENTS: REQUEST_MAPPING.DEPARTMENTS + "/sub-departments",
  GET_TEAMS: REQUEST_MAPPING.DEPARTMENTS + "/teams",
  GET_ALL_HEADS: REQUEST_MAPPING.DEPARTMENTS + "/all-heads",

  // Meeting managements
  GET_ALL_MEETING_MANAGEMENTS: REQUEST_MAPPING.MEETING_MANAGEMENTS,
  REGISTER_MEETING_MANAGEMENTS: REQUEST_MAPPING.MEETING_MANAGEMENTS,
  REMOVE_MEMBER_TARGET:
    REQUEST_MAPPING.TARGET_SETTING_V1 + "/remove-member-target",

  // Data collection
  GET_MONTH_DATA: REQUEST_MAPPING.DATA_COLLECTION + "/data",
  GET_HEAD_DATA: REQUEST_MAPPING.DATA_COLLECTION + "/data/member",
  EXPORT_MONTH_DATA:
    REQUEST_MAPPING.DATA_COLLECTION + "/export-data-collection",
  GET_TIMELINE: REQUEST_MAPPING.DATA_COLLECTION + "/timeline",
};
export const ROLE_ADMIN = {
  roleId: 1,
  roleName: "管理者",
  roleCode: "ADMIN",
};
export const ROLE_HEAD = {
  roleId: 2,
  roleName: "本部長",
  roleCode: "HEAD",
};
export const ROLE_DEPUTY = {
  roleId: 3,
  roleName: "部長",
  roleCode: "DEPUTY",
};
export const ROLE_MANAGER = {
  roleId: 4,
  roleName: "MGR",
  roleCode: "MANAGER",
};
export const ROLE_USER = {
  roleId: 5,
  roleName: "担当者",
  roleCode: "USER",
};
export const ROLE_PLAN = {
  roleId: 6,
  roleName: "計画本部",
  roleCode: "PLAN",
};
export const ROLE_HR = {
  roleId: 7,
  roleName: "人事部",
  roleCode: "HR",
};
export const ROLE_MEETING = {
  roleId: 8,
  roleName: "経営会議",
  roleCode: "MEETING",
};
export const ROLE_ENUMS = [
  ROLE_ADMIN,
  ROLE_HEAD,
  ROLE_DEPUTY,
  ROLE_MANAGER,
  ROLE_USER,
  ROLE_PLAN,
  ROLE_HR,
  ROLE_MEETING,
];
export const ROLE_RULINGS = [ROLE_HEAD, ROLE_DEPUTY, ROLE_MANAGER];
export const ROLE_INCLUDE_MOBILE = [
  ROLE_USER.roleCode,
  ROLE_HEAD.roleCode,
  ROLE_DEPUTY.roleCode,
  ROLE_MANAGER.roleCode,
];

export const ROLE_EXCLUDE_MOBILE = [
  ROLE_ADMIN.roleCode,
  ROLE_MEETING.roleCode,
  ROLE_HR.roleCode,
];

export const ROLE_COMMON_ENUMS = [
  ROLE_HEAD,
  ROLE_DEPUTY,
  ROLE_MANAGER,
  ROLE_USER,
];

export const MENU_HOME = [
  {
    icon: "mdi-format-list-checks",
    title: "pageHome.target",
    path: "/team-target",
    menuPaths: ["/team-target", "/personal-target"],
    authorities: [
      ROLE_HEAD.roleCode,
      ROLE_DEPUTY.roleCode,
      ROLE_MANAGER.roleCode,
      ROLE_MEETING.roleCode,
    ],
  },
  {
    icon: "mdi-format-list-checks",
    title: "pageHome.target",
    path: "/personal-target",
    menuPaths: ["/personal-target", "/team-target"],
    authorities: [ROLE_USER.roleCode],
  },
  {
    icon: "mdi-bullseye-arrow",
    title: "pageHome.evaluation",
    path: "/target-settings",
    menuPaths: ["/target-settings", "/target-setting"],
    authorities: ["PLAN", "HEAD"],
  },
  {
    icon: "mdi-cog",
    title: "pageHome.settingCommon",
    path: "/setting-common",
    menuPaths: ["setting-common"],
    authorities: ["ADMIN", "HR"],
  },
  {
    icon: "mdi-clipboard-text-clock-outline",
    title: "pageHome.history",
    path: "/history",
    menuPaths: ["history"],
    authorities: ["HR"],
  },
  {
    icon: "mdi-account-box-multiple",
    title: "pageHome.memberTransfer",
    path: "/member-transfer-setting",
    menuPaths: ["/member-transfer-setting"],
    authorities: ["HR"],
  },
  {
    icon: "mdi-chart-bar",
    title: "pageHome.dataCollection",
    path: "/data-collection",
    menuPaths: ["/data-collection"],
    authorities: ["HR"],
  },
];

export const ITEMS_PER_PAGE = [10, 50, 100];

export const PAGING_CONFIG = {
  circle: true,
  nextIcon: "mdi-chevron-right",
  prevIcon: "mdi-chevron-left",
  totalVisible: 10,
  itemsPerPage: ITEMS_PER_PAGE,
};

export const PAGINATION = {
  page: 1,
  itemsPerPage: 10,
  pageStart: 0,
  pageStop: 0,
  pageCount: 0,
  itemsLength: 0,
};

export const HEADER_TABLE_TARGET_SETTINGS = [
  { text: "#", align: "start", value: "index", sortable: false },
  {
    text: "本部署",
    value: "headName",
    sortable: true,
  },
  { text: "役職", value: "roleId", sortable: true },
  { text: "設定者", value: "creatorName", sortable: true },
  { text: "承認者", value: "approverName", sortable: true },
  { text: "期間", align: "center", value: "targetYear", sortable: true },
  { text: "状態", value: "targetSettingStatus", sortable: true },
  { text: "", align: "center", value: "actions", sortable: false },
];

export const HEADER_TABLE_TRANSFER_MEMBER_SETTINGS = [
  {
    text: "#",
    align: "start",
    value: "index",
    sortable: false,
    class: "mw-50",
  },
  { text: "社員番号", value: "memberId", sortable: true, class: "mw-120" },
  { text: "社員名", value: "memberName", sortable: true, class: "mw-120" },
  {
    text: "旧部署",
    value: "oldDepartName",
    sortable: true,
    class: "mw-120",
  },
  {
    text: "旧役職",
    value: "oldPermissionId",
    sortable: true,
    class: "mw-120",
  },
  {
    text: "評価テーブル",
    value: "cpTableName",
    sortable: true,
    class: "mw-150",
  },
  { text: "新部署", value: "departName", sortable: true, class: "mw-120" },
  { text: "役職", value: "position", sortable: true, class: "mw-120" },
  {
    text: "アクション",
    value: "action",
    align: "center",
    sortable: false,
    class: "mw-120",
  },
];

export const HEADER_TABLE_HISTORY = [
  { text: "#", value: "index", sortable: false, align: "center" },
  { text: "社員番号", value: "memberId", sortable: true, align: "left" },
  { text: "名前", value: "kanjiName", sortable: true, align: "left" },
  { text: "本部署", value: "head", sortable: true, align: "left" },
  { text: "部署", value: "department", sortable: true, align: "left" },
  { text: "チーム", value: "team", sortable: true, align: "left" },
  { text: "期間", value: "duration", sortable: true, align: "left" },
  { text: "役職", value: "permissionName", sortable: true, align: "left" },
  {
    text: "プロセス目標の状態",
    value: "targetStatus",
    sortable: false,
    align: "left",
  },
  {
    text: "個人目標<br />設定",
    value: "action",
    sortable: false,
    align: "center",
  },
];

export const HEADER_TABLE_DATA_COLLECTION = [
  { text: "#", value: "index", sortable: false, align: "center" },
  { text: "本部署", value: "headId", sortable: true, align: "left" },
  { text: "入力状況", value: "inputStatus", sortable: false, align: "left" },
  { text: "入力率", value: "inputRate", sortable: false, align: "left" },
  { text: "", value: "action", sortable: false, align: "left" },
];

export const HEADER_TABLE_DATA_COLLECTION_DETAIL = [
  { text: "#", value: "index", sortable: false, align: "center" },
  { text: "社員番号", value: "memberId", sortable: true, align: "left" },
  { text: "名前", value: "memberName", sortable: true, align: "left" },
  { text: "部署", value: "departId", sortable: true, align: "left" },
  { text: "チーム", value: "teamId", sortable: true, align: "left" },
  { text: " 役職", value: "permissionId", sortable: true, align: "left" },
  { text: "入力状況", value: "inputStatus", sortable: false, align: "left" },
];

export const TARGET_SETTING_ALL = { text: "全て", code: "ALL", value: 0 };
export const TARGET_SETTING_NEW = {
  text: "新規",
  code: "NEW",
  value: 1,
  color: "default",
  textColor: "black",
};
export const TARGET_SETTING_SEND = {
  text: "承認待ち",
  code: "SEND",
  value: 2,
  color: "warning",
  textColor: "white",
};
export const TARGET_SETTING_REJECTED = {
  text: "差し戻し",
  code: "REJECTED",
  value: 3,
  color: "red",
  textColor: "white",
};
export const TARGET_SETTING_APPROVED = {
  text: "承認済み",
  code: "APPROVED",
  value: 4,
  color: "green",
  textColor: "white",
};
export const TARGET_SETTING_STATUS = [
  TARGET_SETTING_ALL,
  TARGET_SETTING_NEW,
  TARGET_SETTING_SEND,
  TARGET_SETTING_REJECTED,
  TARGET_SETTING_APPROVED,
];
export const TYPE_TARGET_CONFIRM_SUBMIT = {
  code: "SUBMIT",
  title: "評価項目申請確認",
  message:
    "設定した評価項目を本部長に申請します。<br>申請したら編集不可になります。よろしいですか？",
  textOk: "申請",
  colorOk: "success",
  action: "submitTarget",
};
export const TYPE_TARGET_CONFIRM_REJECT = {
  code: "REJECT",
  title: "評価項目却下確認",
  message:
    "評価項目を差し戻します。<br>差し戻したら評価項目の作成者に戻します。よろしいですか？",
  textOk: "差し戻し",
  colorOk: "error",
  action: "rejectTarget",
};
export const TYPE_TARGET_CONFIRM_APPROVE = {
  code: "APPROVE",
  title: "評価項目承認確認",
  message:
    "評価項目を承認します。<br>承認したら本部署内のメンバは評価項目を確認可能になります。よろしいですか？",
  textOk: "承認",
  colorOk: "success",
  action: "approveTarget",
};
export const TYPE_TARGET_CONFIRM_CANCEL = {
  code: "CANCEL",
  title: "編集保存確認",
  message: "編集した情報があります。保存しますか？",
  textOk: "保存しない",
  colorOk: "primary",
  action: "cancelTarget",
};

export const TYPE_TARGET_CONFIRM_ROLLBACK = {
  code: "ROLLBACK",
  title: "承認取り消し確認",
  message: "評価項目が取り消されますが、よろしいでしょうか？",
  textOk: "取り消す",
  colorOk: "primary",
  action: "rollbackTarget",
};

export const TYPE_TARGET_CONFIRM_WARNING = {
  code: "PROCESS_WARNING",
  title: "警告",
  textOk: "次へ",
  colorOk: "primary",
  action: "continue",
};

export const TYPE_TARGET_CONFIRMS = [
  TYPE_TARGET_CONFIRM_SUBMIT,
  TYPE_TARGET_CONFIRM_REJECT,
  TYPE_TARGET_CONFIRM_APPROVE,
  TYPE_TARGET_CONFIRM_CANCEL,
  TYPE_TARGET_CONFIRM_ROLLBACK,
  TYPE_TARGET_CONFIRM_WARNING,
];

export const TYPE_PROCESS_TARGET_CONFIRM_SUBMIT = {
  code: "PROCESS_SUBMIT",
  title: "プロセス目標申請確認",
  message: i18n.t("pagePersonalTarget.process.submitConfirm"),
  textOk: "申請",
  colorOk: "primary",
  action: "submitProcessTarget",
};
export const TYPE_PROCESS_TARGET_CONFIRM_APPROVE = {
  code: "PROCESS_APPROVE",
  title: "プロセス目標承認確認",
  message: "プロセス目標を承認しますか？",
  textOk: i18n.t("index.btn.approve"),
  colorOk: "primary",
  action: "approveProcessTarget",
};

export const TYPE_PROCESS_TARGET_CONFIRM_REJECT = {
  code: "PROCESS_REJECT",
  title: "プロセス目標の差し戻し確認",
  message: "プロセス目標を差し戻しますか？",
  textOk: i18n.t("index.btn.reject"),
  colorOk: "error",
  action: "rejectProcessTarget",
};

export const ACTION_REVIEW_ALL = {
  code: "ACTION_REVIEWED",
  title: "REVIEWED",
  color: "success",
  action: "reviewAllUser",
};

export const TYPE_PROCESS_TARGET_CONFIRMS = [
  TYPE_PROCESS_TARGET_CONFIRM_SUBMIT,
  TYPE_PROCESS_TARGET_CONFIRM_APPROVE,
  TYPE_PROCESS_TARGET_CONFIRM_REJECT,
];

export const FILTER_TARGET_SETTING_REQUEST = {
  headIds: "",
  selectedHeads: [],
  fromYear: new Date().getFullYear(),
  toYear: new Date().getFullYear() + 1,
  periodStatus: TARGET_SETTING_STATUS[0].value,
  creatorKey: "",
  approverKey: "",
};

export const FILTER_HISTORY_REQUEST = {
  memberName: "",
  headName: "",
  departmentName: "",
  teamName: "",
  period: "",
  role: "",
};

export const REQUIRED_OPTIONS = [
  { text: "あり", value: true },
  { text: "なし", value: false },
];

export const UNIT_OPTIONS = [
  { text: "％", value: 1, meaning: "percent" },
  { text: "時間", value: 2, meaning: "hour" },
  { text: "数値", value: 3, meaning: "normalNumber" },
];

export const FORMULA_OPTIONS = [
  { text: "合計", value: 1, meaning: "total" },
  { text: "平均", value: 2, meaning: "average" },
];

export const CALCULATION_OPTIONS = [
  { text: "要", value: true },
  { text: "否", value: false },
];

export const ORDER_OPTIONS = [
  { text: "降順", value: 1, meaning: "DES" },
  { text: "昇順", value: 2, meaning: "ASC" },
];

export const COMMENT_TYPE = {
  101: "COMPREHENSIVE_1",
  102: "COMPREHENSIVE_2",
  103: "COMPREHENSIVE_3",
  201: "BOSS_1",
  202: "BOSS_2",
  203: "BOSS_3",
  301: "PERSONAL_1",
  302: "PERSONAL_2",
  303: "PERSONAL_3",
};

export const PROCESS_COMMENT_TYPE = {
  101: "ACHIEVEMENT",
  201: "SCORE",
  301: "BOSS",
  401: "PERSONAL",
  501: "PERSONAL_2",
  601: "SCORE_2",
};

export const PROCESS_TARGET_NEW = {
  id: 1,
  text: "NEW",
  value: "NEW",
};

export const PROCESS_TARGET_WAIT_APPROVE = {
  id: 2,
  text: "WAIT_APPROVE",
  value: "WAIT_APPROVE",
};

export const PROCESS_TARGET_REJECTED = {
  id: 3,
  text: "REJECTED",
  value: "REJECTED",
};

export const PROCESS_TARGET_APPROVED = {
  id: 4,
  text: "APPROVED",
  value: "APPROVED",
};

export const TARGET_SETTING_TYPE = [
  {
    id: ROLE_HEAD.roleId,
    text: ROLE_HEAD.roleName,
    value: ROLE_HEAD.roleCode.toLowerCase(),
  },
  {
    id: ROLE_DEPUTY.roleId,
    text: ROLE_DEPUTY.roleName,
    value: ROLE_DEPUTY.roleCode.toLowerCase(),
  },
  {
    id: ROLE_MANAGER.roleId,
    text: ROLE_MANAGER.roleName,
    value: ROLE_MANAGER.roleCode.toLowerCase(),
  },
  {
    id: ROLE_USER.roleId,
    text: ROLE_USER.roleName,
    value: ROLE_USER.roleCode.toLowerCase(),
  },
];

export const MAX_ASSESSMENT_CONFIG_DESCRIPTION_LENGTH = 255;
export const MAX_LENGTH_PROCESS_COMMENT = 255;
export const MAX_LENGTH_CHECKPOINT_TABLE_NAME = 50;
export const MAX_LENGTH_TARGET_NAME = 50;
export const MAX_TOTAL_WEIGHT = 100;
export const MAX_MEMBER_FILE_SIZE = 5; // MB
export const MAX_MEMBER_FILE_NAME_LENGTH = 512;
export const MAX_GRADE = 999999999;
export const MAX_LENGTH_PERSONAL_TARGET = 255;

export const SPACE_JP = "　";
export const SPACE_EN = " ";
export const DEFAULT_VALUE = {
  text: "すべて",
  value: null,
};

export const TYPES_FILTER_MEMBER = [
  {
    text: "すべて",
    value: 0,
  },
  {
    text: "評価テーブルあり",
    value: 1,
  },
  {
    text: "評価テーブルなし",
    value: 2,
  },
];

export const TYPES_FILTER_DEPARTMENT = [
  {
    text: "すべて",
    value: 0,
  },
  {
    text: "選択した",
    value: 1,
  },
  {
    text: "未選択",
    value: 2,
  },
];

export const TYPES_FILTER_TABLE = [
  {
    text: "すべて",
    value: 0,
  },
  {
    text: "選択した",
    value: 1,
  },
  {
    text: "未選択",
    value: 2,
  },
];

export const TRANSFERED_MEMBER_STATUS = [
  {
    value: "未移動",
  },
  {
    value: "移動済み",
  },
];

export const EMPTY_VALUE = {
  value: "なし",
};
export const TYPE_TRANSFER_MEMBER = [
  {
    text: "選択した",
    value: "0",
  },
  {
    text: "未選択",
    value: "1",
  },
];

export const TARGET_MEMBER_TYPES = {
  PERSONAL: "PERSONAL",
  TEAM: "TEAM",
};

export const TEAM_TARGET_FIELD_NAME_EN = {
  MEMBER_NAME: "memberName",
  DEPARTMENT_NAME: "departmentName",
};

export const decimalNumber = 0.000000001;

export const MEETING_MANAGEMENT_VISIBLE_CHIPS = 3;

export const DEFAULT_MAX_TARGET_VALUE = 10;
export const MAX_INT_VALUE = 2147483647;
export const DEFAULT_MIN_GRADE = 1;
export const DEFAULT_MAX_GRADE = 20;
export const MIN_SCORE = 1;
export const MIN_TIME_ALERT = 1;
export const MAX_TIME_ALERT = 60;

export const TARGET_PERSON_MONTHS = [3, 6, 12];
export const SETTING_TYPES = {
  SETTING_MAX_TARGET_SCORE: "settingMaxTargetScore",
  ASSESSMENT_CONFIG: "assessmentConfig",
  GRADE_CONFIG: "gradeConfig",
  CAN_VIEW_PEERS: "canViewPeers",
  HR_DEPARTMENTS: "HrDepartments",
  MEETING_MANAGEMENT: "MeetingManagement",
};

export const DEFAULT_CAN_VIEW_PEERS = false;

// office, image, video, pdf
export const MEMBER_FILE_TYPES = [
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.ms-powerpoint",
  "image/*",
  "video/*",
];

export const SYNC_TYPES = {
  DEFAULT: "DEFAULT",
  CHANGED_HEAD: "CHANGED_HEAD",
  CHANGED_DEPARTMENT: "CHANGED_DEPARTMENT",
  CHANGED_TEAM: "CHANGED_TEAM",
  CHANGED_ROLE: "CHANGED_ROLE",
  CHANGED_PERMISSION: "CHANGED_PERMISSION",
  NEWBIE: "NEWBIE",
  REMOVED: "REMOVED",
};

export const PROCESS_TARGET_STATUS_VALUES = {
  NEW: "NEW",
  WAIT_APPROVE: "WAIT_APPROVE",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
};

export const PROCESS_TARGET_STATUSES = [
  { text: "未申請", value: "NEW" },
  { text: "申請中", value: "WAIT_APPROVE" },
  { text: "承認済み", value: "APPROVED" },
  /*{ text: "差し戻し", value: "REJECTED" },*/
];

export const MONTH_ITEMS = [
  { text: "01 月", value: "01" },
  { text: "02 月", value: "02" },
  { text: "03 月", value: "03" },
  { text: "04 月", value: "04" },
  { text: "05 月", value: "05" },
  { text: "06 月", value: "06" },
  { text: "07 月", value: "07" },
  { text: "08 月", value: "08" },
  { text: "09 月", value: "09" },
  { text: "10 月", value: "10" },
  { text: "11 月", value: "11" },
  { text: "12 月", value: "12" },
];

export const HISTORY_TYPE_VALUES = {
  PERIOD: "PERIOD",
  MONTH: "MONTH",
};

export const HISTORY_TYPES = [
  { text: "年度", value: HISTORY_TYPE_VALUES.PERIOD },
  { text: "月度", value: HISTORY_TYPE_VALUES.MONTH },
];

export const NULL_DEPARTMENT_CODE_DEFAULT = "000000";

export const PERSONAL_CARD = [
  { text: "ミッション", value: "mission" },
  { text: "部署･上司の目標", value: "goal" },
  { text: "自身の行動目標", value: "personalGoal" },
  { text: "ミッション", value: "personalTargetMission" },
  { text: "部署･上司の目標", value: "personalTargetGoal" },
  { text: "評価期末　上司コメント", value: "BOSS_1" },
  { text: "評価期末　本人コメント", value: "PERSONAL_1" },
];

export const PERSONAL_TARGET = [
  {
    text: "観察（課題の抽出と絞り込み）",
    value: "observation",
    param: "observation",
  },
  { text: "分析（原因）", value: "analysis", param: "analysis" },
  { text: "判断（打ち手）", value: "judge", param: "judge" },
  {
    text: "数値目標（達成水準）",
    value: "targetNumber",
    param: "targetNumber",
  },
  {
    text: "打ち手（当月修正・追加事項）",
    value: "achievement",
    param: "commentValue",
  },
  {
    text: "上司のコメント",
    value: "boss",
    param: "commentValue",
  },
  {
    text: "できたこと・できなかったこと・ 反省点・次月活かすこと等",
    value: "personal",
    param: "commentValue",
  },
  {
    text: "当月学習事項",
    value: "learnCurrentMonth",
    param: "commentValue",
  },
];
